export const FETCH_PROVERB = "FETCH_PROVERB";
export const fetchProverbAction = (proverb) => {
    return {
        type: "FETCH_PROVERB",
        payload: proverb
    }
}

export const FETCH_COUNTER = "FETCH_COUNTER";
export const fetchCounterAction = (counter) => {
    return {
        type: "FETCH_COUNTER",
        payload: counter
    }
}